import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

// This function creates a set of function that helps us create multipart component styles.
const helpers = createMultiStyleConfigHelpers(['navigatorGroup', 'navigatorItem'])

const Navigator = helpers.defineMultiStyleConfig({
  baseStyle: {
    navigator: {
      pos: 'fixed',
      h: 'full',
      w: { lg: '252px' },
      flexDirection: 'column',
      bgColor: 'bg.navigator',
      //p: '24px 20px', 
      py: '24px',
      pl: '20px', 
      //overflowY: 'auto'
    },
    navigatorScrollArea: {
      display: 'flex',
      flexDir: 'column',
      overflowY: 'auto',
      overflowX: 'hidden',
      flex: 1,
      pr: '20px',
    },
    navigatorGroup: {
      mt: '32px',
      span: {
        fontSize: '10px',
        fontWeight: 'medium',
        lineHeight: '160%',
        letterSpacing: '0.4px',
        textTransform: 'uppercase'
      },
      ul: {
        mt: '12px'
      },
    },
    navigatorItem: {
      w: 'full',
      'a, button': {
        pos: 'relative',
        w: 'full',
        transition: 'background-color 0.3s ease, color 0.3s ease',
        justifyContent: 'flex-start',
        p: '8px 8px 8px 12px',
        fontSize: '14px',
        fontWeight: 'medium',
        letterSpacing: '-0.3px',
        span: {
          transition: 'color 0.3s ease',
        },
        'span:last-child': {
          transition: 'opacity 0.3s ease',
          opacity: 0,
          ml: 'auto',
        },
        '&:before': {
          content: '""',
          pos: 'absolute',
          transform: 'translateX(-200px)',
          transition: 'transform 0.3s ease',
          w: '4px',
          h: '20px',
          borderRadius: '0px 4px 4px 0px',
          bgColor: 'bg.navigatorItem.active',
        },
        _hover: {
          bgColor: 'bg.navigatorItem.hover',
          'span:last-child': {
            opacity: 1
          }
        },
        '&.active': {
          color: 'text.navigatorItem.active',
          bgColor: 'bg.navigatorItem.hover',
          'span:first-child': {
            color: 'bg.navigatorItem.active'
          },
          '&:before': {
            transform: 'translateX(-32px)',
          },
          'span:last-child': {
            opacity: 1
          }
        }
      }
    },
  }
});

export default Navigator;